import { Lock } from 'lucide-react'
import { Link } from 'react-router'

import { ProfileSection } from './profile-section'

const PLACEHOLDER_WIDTHS = ['w-3/4', 'w-1/2', 'w-2/3', 'w-5/12']

/** the server sends nothing for a locked section: these bars are placeholders
 *  under the blur, never real values. */
export function ProfileLocked({
  title,
  signupHref
}: {
  title: string
  signupHref: string
}) {
  return (
    <ProfileSection title={title}>
      <div className='relative'>
        <div
          aria-hidden='true'
          className='flex flex-col gap-3 py-2 blur-sm select-none'
        >
          {PLACEHOLDER_WIDTHS.map(width => (
            <div key={width} className={`h-3 rounded bg-muted ${width}`} />
          ))}
        </div>
        <Link
          to={signupHref}
          className='absolute inset-0 flex items-center justify-center gap-2 text-sm font-medium text-accent no-underline hover:underline dark:text-accent-mid'
        >
          <Lock className='size-4' />
          Sign up for free to view full information
        </Link>
      </div>
    </ProfileSection>
  )
}
